import Model from '@/app/Model'
import { User } from '@/models/User'

export class Company extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			picture: {},
			vatCode: null,
			registrationCode: null,
			registrationAddress: null,
			billingDetails: null,
			accountantEmail: null,
			testingCompany: null,
			onlyShipments: null,
			softwareCharge: null,
			serviceName: null,
			softwareDiscount: null,
			country: null,
			city: null,
			hqAddress: null,
			bankName: null,
			iban: null,
			bankCode: null,
			deleted: null,
			swiftCode: null,
			partsCount: null,
			manager: User,
			departments: {
				id: null,
				name: null
			}
		}
	}

	static hasMany () {
		return {
		}
	}
}

export function createCompany (data) {
	return Object.freeze(new Company(data))
}
